import { RSAA, RSAAction } from 'redux-api-middleware';
import { CMS_API } from 'store/api';

import * as types from './faqActionTypes';

export const fetchFAQ = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    api: CMS_API,
    endpoint: 'faqs',
    method: 'GET',
    types: [types.FETCH_FAQ_REQUEST, types.FETCH_FAQ_SUCCESS, types.FETCH_FAQ_FAILURE],
  },
});
